import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tab, Nav, NavItem } from 'react-bootstrap';
import uuid from 'uuid/v4';

class TabsButtonGroup extends React.Component {
  state = {
    key: `${this.props.id}-event-key-0`
  };

  handleSelect = key => this.setState({ key });

  generateEventKey = index => `${this.props.id}-event-key-${index}`;

  renderNav = () => (
    <Nav className="tvt-nav-tabs">
      {React.Children.map(this.props.children, (child, index) => (
        <NavItem eventKey={this.generateEventKey(index)}>
          {child.props.icon ? child.props.icon : index}
        </NavItem>
      ))}
    </Nav>
  );

  renderInfo = () => (
    <Tab.Content bsClass="tvt-info-group">
      {React.Children.map(this.props.children, (child, index) => (
        <Tab.Pane
          eventKey={this.generateEventKey(index)}
          className="tvt-info-group__child"
        >
          {child.props.info ? child.props.info : ''}
        </Tab.Pane>
      ))}
    </Tab.Content>
  );

  renderChildren = () => (
    <Tab.Content>
      {React.Children.map(this.props.children, (child, index) => (
        <Tab.Pane
          unmountOnExit
          eventKey={this.generateEventKey(index)}
          className="tvt-tabs-button-group__child"
        >
          {child}
        </Tab.Pane>
      ))}
    </Tab.Content>
  );

  render() {
    return (
      <Tab.Container
        activeKey={this.state.key}
        defaultActiveKey={this.state.key}
        onSelect={this.handleSelect}
        id={`tvt-tabs-button-group-${this.props.id}`}
        className="tvt-tabs-button-group__container"
      >
        <Row>
          <Col sm={12} className="tvt-tabs-button-group__navigation">
            {this.renderNav()}
            {this.renderInfo()}
          </Col>
          <Col sm={12}>{this.renderChildren()}</Col>
        </Row>
      </Tab.Container>
    );
  }
}

TabsButtonGroup.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired
};

TabsButtonGroup.defaultProps = {
  id: uuid()
};

export default TabsButtonGroup;
